// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__2mWTE","head":"ProcedureTableInfo_head__2Owc8"};